// eslint-disable-next-line import/no-anonymous-default-export
export default {
  mapNodes(nodes) {
    return nodes.map(node => {
      return {
        id: node.key,
        key: node.key,
        data: {
          label: node.label,
          active: node.isActive ? 'True' : 'False',
          isActive: node.isActive,
        },
        children:
          !node.children || node.children.length === 0
            ? null
            : (node.children as any[]).map((child: any) => {
                return {
                  id: child.key,
                  key: child.key,
                  data: {
                    label: child.label,
                    active: child.isActive ? 'True' : 'False',
                    isActive: child.isActive,
                  },
                };
              }),
      };
    });
  },

  findNodeByKey(nodes, key) {
    let counter = 0;
    let node;

    while (counter < nodes.length) {
      node = nodes.filter(node => node.key === key)[0];
      if (!node && nodes[counter].children?.length > 0) {
        node = this.findNodeByKey(nodes[counter].children, key);
      }
      counter++;
      if (node) {
        counter = nodes.length;
      }
    }

    return node;
  },

  requiredValidator(e) {
    const props = e.columnProps;
    const value = props.node.data[props.field];

    return value && value.length > 0;
  },
};
